import {
  Box,
  CircularProgress,
  IconButton,
  Button as MUIButton,
} from '@mui/material';

import { LOADING_SIZE } from './constants';
import { IButtonProps, IIconButtonProps } from './types';

import './styles.scss';

export const Button = ({
  children,
  loading,
  'data-testid': dataTestId,
  ...props
}: IButtonProps) => {
  const { size } = props;

  return (
    <MUIButton
      className='loading-button'
      disabled={loading}
      data-testid={dataTestId}
      role='button'
      {...props}
    >
      {loading && (
        <CircularProgress
          className='loading'
          size={LOADING_SIZE[size || 'small']}
          color='inherit'
          data-testid={dataTestId}
        />
      )}

      <Box className={`container-children ${loading ? 'loading' : ''}`}>
        {children}
      </Box>
    </MUIButton>
  );
};

export const LoadingIconButton = ({
  loading,
  icon,
  ...props
}: IIconButtonProps) => {
  const { size } = props;

  return (
    <IconButton disabled={loading} {...props}>
      {loading ? (
        <CircularProgress
          size={LOADING_SIZE[size || 'small']}
          color='inherit'
        />
      ) : (
        icon
      )}
    </IconButton>
  );
};
